// extracted by mini-css-extract-plugin
export default {"descriptor":"descriptor_descriptor__wZmnK","default":"descriptor_default__dCK5y"};